import {
  ADDRESS_FIAS_LEVEL_COUNTRY_HOUSE,
  ADDRESS_FIAS_LEVEL_LAND_HOUSE,
  ADDRESS_FIAS_LEVEL_HOUSE,
} from '@sravni/cosago-react-library/lib/validationSchemes';

import type { TDadataFullAddressSelectOption } from 'shared/types';

/**
 * @url https://support.dadata.ru/knowledge-bases/4/articles/1059-urovni-fias-i-urovni-adresa-dadatyi
 * 8 - дом, 65 - планировочная структура, 75 - участок, хозяйство
 */
const FIAS_LEVELS_WITH_DEFINED_HOUSE = [
  String(ADDRESS_FIAS_LEVEL_COUNTRY_HOUSE),
  String(ADDRESS_FIAS_LEVEL_LAND_HOUSE),
  String(ADDRESS_FIAS_LEVEL_HOUSE),
];

/**
 * Проверяет, что в адресе достаточно данных для определения дома:
 * - есть населённый пункт или улица,
 * - указан fias_level из списка,
 * - и при этом заполнен house, либо уровень ФИАС уже соответствует улице.
 */
export const isAddressDataHasHouse = (data: TDadataFullAddressSelectOption['data']) => {
  const { house, street, street_with_type, city, city_with_type, settlement, settlement_with_type, fias_level } = data;

  const placeValue = city || settlement || city_with_type || settlement_with_type;
  const streetValue = street || street_with_type;

  const hasAddressBase = Boolean(streetValue || placeValue);
  const hasFiasLevel = Boolean(fias_level);
  const hasHouse = Boolean(house);
  const isHouseLevel = FIAS_LEVELS_WITH_DEFINED_HOUSE.includes(String(fias_level));

  return hasAddressBase && hasFiasLevel && (hasHouse || isHouseLevel);
};
